import RymApp from '@/utils/native'
/**
 * @description 时间格式化
 * @param {string} date date string
 * @param {string} pattern 时间格式
 * @return {string}
 */
export function formatDate (date, pattern) {
  if (!date) return ''
  if (!pattern) pattern = 'YYYY-MM-DD hh:mm:ss'

  const d = new Date(date)
  let str = pattern
  const types = ['YYYY', 'MM', 'DD', 'hh', 'mm', 'ss']
  const dates = [d.getFullYear(), d.getMonth() + 1, d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds()]

  for (let i = 0; i < types.length; i++) {
    str = str.replace(types[i], (dates[i] < 10 ? ('0' + dates[i]) : dates[i]))
  }

  return str
}

export function isObject (target) {
  return typeof target === 'object' && target !== null
}

export function isPrdEnv () {
  const { host } = window.location
  return /^maam-res\.pingan\.com\.cn/.test(host)
}

export function isWxEnv () {
  const ua = navigator.userAgent.toUpperCase()
  return ua.includes('MICROMESSENGER')
}

export function isWxMiniProgramEnv () {
  const ua = navigator.userAgent.toUpperCase()
  return ua.includes('MICROMESSENGER') && ua.includes('MINIPROGRAM')
}

export function initH5TrackSdk () {
  window.pingan_sdk_appid = isPrdEnv() ? '97750A70867132C5E0CFBA22762BEA7E' : 'D7D5CE3B1268DE33D8CDCAE17042E660'
  window.pingan_sdk_vn = 'v1'
  window.pingan_sdk_vc = '1.0.0'
}

/**
 * @description 动态加载script
 */
export function loadScript (src) {
  return new Promise((resolve) => {
    var script = document.createElement('script')
    script.charset = 'UTF-8'
    script.onload = script.onreadystatechange = function () {
      if (!script.readyState || script.readyState === 'loaded' || script.readyState === 'complete') {
        resolve()
      }
    }
    script.src = src
    document.getElementsByTagName('head')[0].appendChild(script)
  })
}

/**
 * 获取年月日
 * @param {number | string} timestamp
 */
export function getDate (timestamp) {
  const date = new Date(timestamp)
  return {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate()
  }
}

/**
 * @description url参数转成对象
 * @param {string} url
 * @return {object}
 */
export function urlParamsToObject (url = window.location.href) {
  if (!url || typeof url !== 'string') return {}
  const strArr = url.split('?') || []
  const queryStr = strArr[strArr.length - 1] ?? ''
  const queryArray = queryStr.split('&')
  const obj = queryArray.reduce((res, cur) => {
    var [key, value = ''] = cur.split('=')
    value = value.split('#')[0]
    if (key) res[key] = value
    return res
  }, {})
  return obj
}

/**
 * @description 从地址栏获取某个参数
 * @param {string} key
 * @param {string} url
 */
export function getParamFromUrl (key, url = window.location.href) {
  if (!key) return ''
  const result = urlParamsToObject(url)
  return result[key] || ''
}

/**
 * @description 将object转化为queryString
 * @param {object} obj
 */
export function objectToQueryString (obj) {
  if (Object.prototype.toString.call(obj) !== '[object Object]') {
    throw new Error('must be Object data type')
  }
  return Object.keys(obj).reduce((res, cur) => {
    res += `&${cur}=${obj[cur] ?? ''}`
    return res
  }, '').slice(1)
}

/**
 * @description 防抖
 * @param {function} func 执行的函数
 * @param {number} wait 在时间内，不会调用触发执行函数
 * @param {boolean} immediate 是否立马执行
 */
export function debounce (func, wait, immediate) {
  let timeout, result
  return function () {
    const context = this
    const args = arguments
    if (timeout) clearTimeout(timeout)
    if (immediate) {
      const callNow = !timeout
      timeout = setTimeout(function () {
        timeout = null
      }, wait)
      if (callNow) result = func.apply(context, args)
    } else {
      timeout = setTimeout(function () {
        func.apply(context, args)
      }, wait)
    }
    return result
  }
}

/**
 *
 * @description 兼容iphone x及以上手机底部tab栏。安卓低版本添加该属性会报错
 */
export function initViewport () {
  const ua = navigator.userAgent.toUpperCase()
  if (ua.indexOf('IPHONE OS') > -1) {
    const meta = document.getElementsByClassName('viewport')[0]
    const content = meta.getAttribute('content')
    meta.setAttribute('content', content + ', viewport-fit=cover')
  }
}

/**
 *
 * @param {*} item
 */
export function openTargetByParams (item) {
  if (RymApp.IS_ANYDOOR) {
    const { openMode, jumpingLink, pluginId = '', h5Url: url = '', minaModel = {} } = item
    const pagePath = minaModel.minaPath || minaModel.miniPath || ''
    const minaId = minaModel.minaAppId || minaModel.minaAppid || minaModel.miniAppid || minaModel.miniAppId || ''
    let params
    if (openMode === '1') { // 0-h5 1-小程序 2-app跳转
      RymApp.asyncCall('openPAMina', { minaId, pagePath })
    } else if (openMode === '2') {
      params = {
        openMode,
        isJumpingApp: 'Y',
        url,
        jumpingLink
      }
    } else {
      params = {
        openMode,
        url,
        pluginUid: pluginId
      }
    }
    RymApp.asyncCall('openPlugin', { pluginInfo: params })
  } else {
    window.location.href = item.jumpingLink || item.h5Url
  }
}

export function setTimeArea (start = 8, end = 20, step = 2) {
  return Array.from({ length: (end - start) / step }, (item, index) => {
    const startTime = start + (index * step)
    const endTime = start + ((index + 1) * step)
    let str = '下午'
    if (startTime < 10) {
      str = '上午'
    } else if (startTime >= 10 && endTime <= 12) {
      str = '中午'
    } else if (startTime >= 18) {
      str = '晚上'
    }
    return (str + `${startTime}:00-${endTime}:00`)
  })
}
